<template>
  <div :class="b()" :style="styleSizeName" ref="main">
    <el-carousel :type="type" :indicator-position="indicator" :interval="interval" :height="height">
      <el-carousel-item
        v-for="item in dataChart"
        :key="item"
        @click="handleClick(item, index)"
        style="heigth:100%important"
      >
        <img :src="item.value" draggable="false" :style="styleName" class="img" @click="goLink" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'swiper2',
  mixins: [init],
  data() {
    return {};
  },
  computed: {
    styleName() {
      return {
        opacity: this.opacity
      };
    },
    indicator() {
      return this.opacity.indicator || 'none';
    },
    opacity() {
      return (this.option.opacity || 100) * 0.01;
    },
    type() {
      return this.option.type || '';
    },
    interval() {
      return this.option.interval || 5000;
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClick(item, index) {
      this.clickFormatter &&
        this.clickFormatter({
          type: index,
          value: item,
          data: this.dataChart
        });
    },
    goLink() {
      this.imgClick();
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.el-carousel {
  width: 100%;
  height: 100% !important;

  /deep/ .el-carousel__container {
    height: 100% !important;
  }
}
</style>
